import React from 'react';
import {useRouter} from 'next/router';

import Card from '../../components/Card';
import Link from '../../components/Link';
import KarmaPill from '../../components/KarmaPill';
import {useAnalytics} from '../../hooks';
import {cx} from '../../util';

const ActivityCard = ({activity}) => {
  const {tracker} = useAnalytics();
  const router = useRouter();

  const onClick = (e) => {
    e.stopPropagation();
    tracker.karmaClickActivity({activity: activity.id});
    if (activity.href) router.push(activity.href);
  };

  return (
    <Card
      onClick={onClick}
      tabIndex={0}
      role="link"
      className={cx(
        'flex justify-between items-center mb-3',
        activity.href && 'cursor-pointer',
      )}
    >
      <div className="mr-5">
        {activity.href ? (
          <Link href={activity.href}>
            <span className="text-indigo font-medium">{activity.label}</span>
          </Link>
        ) : (
          <span className="text-indigo font-medium">{activity.label}</span>
        )}
        {activity.description && (
          <div className="text-gray-400 text-xs">
            {activity.description}
          </div>
        )}
      </div>
      <KarmaPill score={activity.value} />
    </Card>
  );
};

export default ActivityCard;
